import { useContext } from 'react';

import { SocketsContext } from '../sockets';

export const useSockets = () => useContext(SocketsContext);
